"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldValidator = void 0;
const models_1 = require("../models");
const result_1 = require("../result");
const validationErrors_1 = require("../models/error/validationErrors");
class FieldValidator {
    constructor() {
        this.rules = [];
    }
    validateRules(value, data) {
        let isSuccess = true;
        const errors = this.rules
            .filter(rule => {
            const isValid = rule.validator.call(this, value, data);
            if (!isValid) {
                isSuccess = false;
                return true;
            }
            return false;
        })
            .map(rule => new models_1.ValidationError(rule.code));
        const validationErrors = new validationErrors_1.ValidationErrors(errors);
        return { isSuccess, validationErrors };
    }
    validate(value, data = {}) {
        const { isSuccess, validationErrors } = this.validateRules(value, data);
        return isSuccess ? result_1.SuccessResult.create(true) : result_1.ErrorResult.create(validationErrors);
    }
}
exports.FieldValidator = FieldValidator;
//# sourceMappingURL=FieldValidator.js.map